import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import tiposSubtiposData from '../../assets/data/tipos-subtipos.json';
import cidadesBairrosData from '../../assets/data/cidades-bairros.json';
import comodidadesData from '../../assets/data/comodidades.json';

import { BuscaAvancadaFilter } from "../model/busca-avancada-filter.model";
import { OldParamsModel } from "../model/oldParams.model";

@Injectable({
   providedIn: 'root'
})
export class UtilService {
   constructor(private route: ActivatedRoute) {}

   fetchBairros() {
      return [
         'Agro-Industrial',
         'Boi Morto',
         'Bonfim',
         'Camobi',
         'Campestre do Menino Deus',
         'Carolina',
         'Caturrita',
         'Centro',
         'Cerrito',
         'Chácara das Flores',
         'Divina Providência',
         'Diácono João Luiz Pozzobon',
         'Dom Antônio Reis',
         'Duque de Caxias',
         'Itararé',
         'Juscelino Kubitschek',
         'Km 3',
         'Lorenzi',
         'Menino Jesus',
         'Nenhum',
         'Noal',
         'Nonoai',
         'Nossa Senhora Medianeira',
         'Nossa Senhora das Dores',
         'Nossa Senhora de Fátima',
         'Nossa Senhora de Lourdes',
         'Nossa Senhora do Perpétuo Socorro',
         'Nossa Senhora do Rosário',
         'Nova Santa Marta',
         "Passo D'Areia",
         'Patronato',
         'Pinheiro Machado',
         'Presidente João Goulart',
         'Pé de Plátano',
         'Renascença',
         'Salgado Filho',
         'São José',
         'São João',
         'Tancredo Neves',
         'Tomazetti',
         'Uglione',
         'Urlândia',
         'Zona rural'
      ];
   }

   fetchCaracteristicas() {
      return comodidadesData;
   }

   fetchTags(): { name: string; value: string }[] {
      return [
         { name: 'Próximo Calçadão', value: 'Próximo Calçadão' },
         { name: 'Exclusividade', value: 'Exclusividade' },
         { name: 'Lançamento', value: 'Lançamento' },
         { name: 'Próximo UFSM', value: 'Próximo UFSM' },
         { name: 'Próximo UFN', value: 'Próximo UFN' },
         { name: 'Minha Casa Minha Vida', value: 'Minha Casa Minha Vida' },
         { name: 'Vídeo', value: 'Vídeo' },
         { name: 'Prime', value: 'Prime' },
         { name: 'Feirão', value: 'feirao' }
      ];
   }

   fetchSubtipos(): string[] {
      return tiposSubtiposData.subtipos;
   }

   fetchCidades(): string[] {
      return Object.keys(cidadesBairrosData);
   }

   public async oldSiteParamToBuscaAvancadaFilter(params: OldParamsModel): Promise<BuscaAvancadaFilter> {
      const { location, status, label, sortby } = params;
      const type = params['type'] || params['type[]'] || null;
      let cidade = undefined;

      if (location) {
         const cidades: string[] = this.fetchCidades();
         cidade = cidades.find((cid) => {
            const cidadeNormalized = cid
               .normalize('NFD')
               .replace(/[\u0300-\u036f]/g, '')
               .replace(/[\s\W-]+/g, '-')
               .toLocaleLowerCase();
            if (cidadeNormalized === params.location) {
               return true;
            }
            return false;
         });
      }

      let contrato = undefined;

      if (status) {
         if (status === 'aluguel') {
            contrato = 'Locação';
         } else if (status === 'venda') {
            contrato = 'Compra';
         }
      }

      let labelsTranslate;
      if (label) {
         const labelsAlias: any = {
            prime: 'alto padrao'
         };

         labelsTranslate = labelsAlias[label];
      }

      let subtipo = undefined;
      if (type) {
         if (type === 'casa-residencial') {
            subtipo = ['Casa'];
         } else if (type === 'apartamento') {
            subtipo = ['Apartamento'];
         }
      }

      const res: BuscaAvancadaFilter = {
         cidade,
         contrato,
         subtipo,
         tags: labelsTranslate,
         sortby: sortby || null
      };
      return res;
   }

   public async getUtmParameters(): Promise<any> {
      const params = this.route.snapshot.queryParamMap;
      console.log(window.location.href);
      return {
         utm_source: params.get('utm_source'),
         utm_medium: params.get('utm_medium'),
         utm_campaign: params.get('utm_campaign'),
         utm_term: params.get('utm_term'),
         utm_content: params.get('utm_content'),
         external_id: params.get('external_id')
      };
   }
}